import { SeeqNames } from '@/main/app.constants.seeqnames';
import { TypeEnum as MentionType } from '@/sdk/model/MentionInputV1';
import type { MentionInputV1 } from '@/sdk/model/MentionInputV1';
import type { MentionSuggestion, SuggestionType } from '@/annotation/mentionEditor/mentionEditor.types';

export const formatMentionId = (suggestion: MentionSuggestion): string => `@${JSON.stringify(suggestion)}`;
export const parseMentionId = (id: string): MentionSuggestion => JSON.parse(id.replace('@', ''));

const transformMentionType = (type: SuggestionType): MentionType =>
  type === SeeqNames.Types.User ? MentionType.User : MentionType.UserGroup;

/**
 * Converts a MentionSuggestion object into a MentionInputV1 object for API consumption.
 *
 * @param {MentionSuggestion} suggestion - The mention suggestion to convert.
 * @param {string} url - The URL associated with the mention (e.g., Vantage room link).
 * @param {string} [source='comment'] - The source context for the mention (e.g., 'comment', 'note').
 * @returns {MentionInputV1} The formatted mention input object.
 */
export const getMentionInputFromSuggestion = (
  suggestion: MentionSuggestion,
  url: string,
  source = 'comment',
): MentionInputV1 => ({
  uuid: suggestion.id,
  type: transformMentionType(suggestion.type),
  name: suggestion.name,
  email: suggestion.email,
  url,
  source,
});
